import { returnProductDataLayerObject, returnVariantDataLayerObject } from '.';

export const pushAddToCartToDataLayer = (product) => {
  let productToAdd;
  let item = product;

  if (item.variant) {
    item = product.variant;
  }

  if (item.priceV2) {
    productToAdd = returnVariantDataLayerObject(item);
  } else if (item.priceRange) {
    productToAdd = returnProductDataLayerObject(item);
  }

  const dataLayerData = {
    event: 'addToCart',
    clientUserAgent: window && window.navigator && window.navigator.userAgent,
    actionSource: 'website',
    eventSourceUrl: process.env.GATSBY_BASE_HOST,
    ecommerce: {
      currencyCode: item.priceV2?.currencyCode || item.priceV2?.currency,
      add: {
        products: [productToAdd],
      },
    },
  };

  if (typeof dataLayer === 'undefined') {
    return;
  }

  if (typeof ga !== 'undefined') {
    ga('require', 'ec');
    ga('ec:addProduct', productToAdd);
    ga('ec:setAction', 'add');
    ga('send', 'event', 'UX', 'click', 'add to cart');
  }

  dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  dataLayer.push(dataLayerData);
};
